import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRetailInvestValue, setRetailInvestValue } from "../../../slices/filters";
export const useRetailInvestValue = () => {
    const dispatch = useDispatch();
    const investValue = useSelector(getRetailInvestValue);
    const update = useCallback((value) => {
        dispatch(setRetailInvestValue(value));
    }, [dispatch]);
    return [investValue, update];
};
